export default __webpack_public_path__ + "static/media/domain-driven.faad59ca.png";